import { render, staticRenderFns } from "./WallChartCalendar.vue?vue&type=template&id=1e35d745"
import script from "./WallChartCalendar.vue?vue&type=script&lang=js"
export * from "./WallChartCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports